export default "__VITE_ASSET__CRWO7MZe__"